import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { RootState } from 'Store'
import { Col, Row, Space, Tabs } from 'antd'
import { menuAdjustStock, menuAdjustStockForBom } from 'helpers/constanst'
import { selectCurrentUser } from 'Store/user/selector'
import { DetailDrawer } from 'Components/common/MainLayout'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import AllowcateForm from './allowcate_form'
import AdjustAtockForm from './adjust_stock_form'
import StockLogsDrawer from './StockLogsDrawer'
import LinkText from 'Components/text/LinkText'
import { StockListData } from 'Store/stock/types'
import ProductInfo from './ProductInfo'
import { getStaffPermission } from 'helpers/account'
const { TabPane } = Tabs

type Props = ReduxProps & {
  visible: boolean
  onCloseDrawer: () => void
  onSuccess?: () => void
  mode: any
  id?: number
  stockData?: StockListData
  currentTab: string
}

const AdjustStock: React.FunctionComponent<Props> = props => {
  const { onCloseDrawer, visible, onSuccess = () => {}, stockData, currentTab } = props

  const [activeTab, setActiveTab] = useState('allocate' as string)
  const [showLogDrawer, setShowLogDrawer] = useState(false)
  const permission = getStaffPermission()
  const hasManageOFStockPermission = permission && permission.includes('/manage-online-offline-stock')
  const hasManageStockOutPermission = permission && permission.includes('/manage-stock-out')

  useEffect(() => {
    setActiveTab(currentTab)
  }, [visible, currentTab])

  const title = (
    <Space>
      <span>ปรับจำนวนสินค้าคงเหลือในคลัง</span>
      {activeTab === 'stock' && <Link onClick={() => setShowLogDrawer(true)}>ประวัติการปรับสินค้า</Link>}
    </Space>
  )

  const onChangeTab = (key: string) => {
    setActiveTab(key)
  }

  const getTab = () => {
    const isBom = stockData?.bom === 1
    const menu = isBom ? menuAdjustStockForBom : menuAdjustStock
    return (
      <StickyHeader>
        <Tabs onChange={onChangeTab} activeKey={activeTab} centered={false}>
          {menu.map((item: any) => {
            if (hasManageOFStockPermission && item?.value === 'allocate') {
              return <TabPane tab={item.name} key={item.value}></TabPane>
            }
            if (hasManageStockOutPermission && item?.value === 'stock') {
              return <TabPane tab={item.name} key={item.value}></TabPane>
            }
            return null
          })}
        </Tabs>
      </StickyHeader>
    )
  }

  const LogsDrawer = (
    <StockLogsDrawer
      isShow={showLogDrawer}
      onClose={() => setShowLogDrawer(false)}
      product_id={stockData?.product_id || 0}
      product_option_id={stockData?.product_option_id || 0}
    />
  )

  return (
    <DetailDrawer title={title} onCloseDrawer={onCloseDrawer} visible={visible} footer={null} width={'80%'}>
      {LogsDrawer}
      <Row justify="space-between" gutter={[16, 32]}>
        <Col md={24} xs={24}>
          <ProductInfo stockData={stockData} />
        </Col>
        <Col md={24} xs={24}>
          {getTab()}
        </Col>
        <Col span={24}>
          {activeTab === 'allocate' ? (
            <AllowcateForm stockData={stockData} onCloseDrawer={onCloseDrawer} onSuccess={onSuccess} />
          ) : (
            <AdjustAtockForm data={stockData} onCloseDrawer={onCloseDrawer} onSuccess={onSuccess} />
          )}
        </Col>
      </Row>
    </DetailDrawer>
  )
}

const StickyHeader = styled.div`
  position: -webkit-sticky;
  position: sticky;
  top: -25px;
  z-index: 1;
`

const Link: any = styled(LinkText)`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(AdjustStock)
